import { useTranslation } from 'react-i18next';
import StandardPage from '@casops/templates/standard-page/StandardPage';
import { Outlet, useParams } from 'react-router-dom';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import { useState } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import NavTabs from '@cas/components/tabs/nav-tabs/NavTabs';
import AssetHeader from './components/header/AssetHeader';
import { useGetAssetQuery } from '@casops/store/apis/registeredAssetsApi';
import useAssetPageTabs from './useAssetPageTabs';
import { useAssetOverviewErrors } from '@casops/hooks/useAssetOverviewErrors';
import { useAssetGroupChips } from '@casops/hooks/useAssetGroupChips';

export function AssetPage() {
  const { t } = useTranslation();
  const { assetId } = useParams();

  // Convert route param string to id number.
  const modelId = typeof assetId !== 'undefined' ? Number(assetId) : undefined;
  const assetPath = `/assets/asset/${modelId}`;

  const [tabs, setTabs] = useState<NavTabModel[]>(() => [
    {
      title: t('Navigation.AssetDetails'),
      to: `${assetPath}/details`,
    },
  ]);

  const queryParams = assetId ? { id: Number(assetId) } : skipToken;

  const { data, ...requestRemainder } = useGetAssetQuery(queryParams, {
    refetchOnMountOrArgChange: 60,
  });
  const assetOverviewErrors = useAssetOverviewErrors({ asset: data });
  const vehicleGroupChips = useAssetGroupChips({ assetGroups: data?.ags });

  useAssetPageTabs({
    assetId,
    assetOverviewErrors,
    assetDeviceType: data?.hw,
    setTabs,
  });

  return (
    <StandardPage
      header={
        <AssetHeader
          asset={data}
          requestRemainder={requestRemainder}
          vehicleGroupChips={vehicleGroupChips}
          modelId={modelId}
        />
      }
    >
      <NavTabs tabs={tabs} hasBorder />
      <Outlet context={{ data, requestRemainder }} />
    </StandardPage>
  );
}

export default AssetPage;
